import {
    Box,
    Button,
    CardContent,
    FormControl,
    FormControlLabel,
    Switch,
    TextField,
    Typography
} from '@material-ui/core';
import { ANAO, ASIM } from 'consts';
import api from '../../../services/api';
import React, { Component } from 'react';
import { validateComboFields } from 'lib/configUtils';
import ComboPadrao from 'views/Components/ComboPadrao';
import { getCodUsuarioRegistrou, validateField } from 'lib/functions';
import AlertInformation from 'components/AlertInformation/AlertInformation';

class ModeloVeiculoForm extends Component {
    state = {
        isNewRecord: false,
        isView: false,
        marcasveiculos: [],
        modeloveiculo: {
            codmodeloveiculo: '',
            codmarcaveiculo: '',
            descmodeloveiculo: '',
            autonomiakmperc: 0,
            inativo: ANAO
        },
        openAlert: false,
        messageAlert: '',
        errors: {},
        schema: {
            descmodeloveiculo: {
                presence: { allowEmpty: false, message: 'Descrição do modelo obrigatória' },
                length: { maximum: 64 },
                type: 'string'
            },
            codmarcaveiculo: {
                presence: { allowEmpty: false, message: 'Marca de veículo obrigatória' },
                length: { maximum: 64 },
                type: 'integer'
            }
        }
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        const { id } = this.props.match.params;
        const { location } = this.props;

        try {
            if (!isNaN(Number(id))) {
                await this.loadModelosVeiculo(id, location.pathname.includes('/view'));
            } else if (id === 'novo') {
                const marcasveiculos = await this.loadMarcasVeiculo();

                this.setState({
                    isNewRecord: true,
                    isView: false,
                    modeloveiculo: this.getModeloVeiculoDefault(),
                    marcasveiculos
                });
            }
        } catch (error) {
            console.error('Erro ao carregar modelo de veículo:', error.response?.data || error.message);

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao carregar modelo de veículo!'
            );
        }
    };

    /* Retorna o modelo de veículo padrão */
    getModeloVeiculoDefault = () => ({
        codmodeloveiculo: '',
        codmarcaveiculo: '',
        descmodeloveiculo: '',
        autonomiakmperc: 0,
        inativo: ANAO
    });

    /* Carrega as marcas de veículo */
    loadMarcasVeiculo = async (codmarcaveiculo) => {
        const url = codmarcaveiculo
            ? `/marcaveiculo/listforchange/${codmarcaveiculo}`
            : '/marcaveiculo/active/true';
        const response = await api.get(url);

        return response.data.data || [];
    };

    /* Carrega os modelos de veículo */
    loadModelosVeiculo = async (id, isView) => {
        const { history } = this.props;

        const response = await api.get(`/modeloveiculo/${id}`);
        const registro = response?.data?.data?.[0];

        if (!registro) {
            this.handleOpenAlert('Modelo de veículo não encontrado!');

            history.push('/frotas/modeloveiculo');

            return;
        }

        const marcasveiculos = await this.loadMarcasVeiculo(registro.codmarcaveiculo);

        this.setState({
            modeloveiculo: {
                codmodeloveiculo: registro.codmodeloveiculo || '',
                codmarcaveiculo: registro.codmarcaveiculo || '',
                descmodeloveiculo: registro.descmodeloveiculo || '',
                autonomiakmperc: registro.autonomiakmperc ?? 0,
                inativo: registro.inativo || ANAO
            },
            isNewRecord: false,
            isView,
            marcasveiculos
        });
    };

    /* Evento onChange componentes */
    onChange = (event) => {
        const { name, type, value, checked } = event.target;

        let adjustedValue =
            type === 'checkbox' ? (checked ? ANAO : ASIM) :
                type === 'radio' ? Number(value) : value.toUpperCase();

        this.setState(prevState => ({
            modeloveiculo: {
                ...prevState.modeloveiculo,
                [name]: adjustedValue
            }
        }));
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Retorna o payload de modelo de veículo */
    getPayloadModeloVeiculo = () => {
        const { modeloveiculo } = this.state;
        const codusuarioregistrou = getCodUsuarioRegistrou();
        const usuarioregistrou = sessionStorage.getItem('usuario') || sessionStorage.getItem('user');

        if (!codusuarioregistrou && !usuarioregistrou) {
            throw new Error('Usuário não encontrado!');
        }

        return {
            codmarcaveiculo: modeloveiculo.codmarcaveiculo || '',
            descmodeloveiculo: modeloveiculo.descmodeloveiculo || '',
            inativo: modeloveiculo.inativo || ANAO,
            autonomiakmperc: modeloveiculo.autonomiakmperc !== '' ? Number(modeloveiculo.autonomiakmperc) : 0,
            codusuarioregistrou,
            usuarioregistrou
        };
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const { modeloveiculo, isNewRecord } = this.state;
        const { history, loadModelosVeiculo } = this.props;

        let errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');

            return;
        }

        const comboErrors = validateComboFields(modeloveiculo, [
            {
                field: 'codmarcaveiculo',
                message: 'Selecione uma marca de veículo válida'
            }
        ]);

        if (Object.keys(comboErrors).length > 0) {
            this.setState(prev => ({
                errors: {
                    ...prev.errors,
                    ...comboErrors
                }
            }));

            this.handleOpenAlert('Selecione registros válidos nos campos indicados em vermelho!');

            return;
        }

        try {
            const payload = this.getPayloadModeloVeiculo();

            if (isNewRecord) {
                await api.post('/modeloveiculo', payload);
            } else {
                await api.put(`/modeloveiculo/${modeloveiculo.codmodeloveiculo}`, payload);
            }

            if (loadModelosVeiculo) loadModelosVeiculo();

            history.push('/frotas/modeloveiculo');
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao salvar!'
            );
        }
    };

    /* Clicar para cancelar */
    onClickCancel = () => {
        this.props.history.push('/frotas/modeloveiculo');
    };

    /* Valida os campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { modeloveiculo, schema } = this.state;
        let errors = {};

        // valida os campos do schema
        const requiredFields = [
            'descmodeloveiculo',
            'codmarcaveiculo'
        ];

        requiredFields.forEach(field => {
            const error = validateField(field, modeloveiculo[field], schema);

            if (error) {
                errors[field] = error;
            }
        });

        return errors;
    };

    /* Trata os campos numéricos não negativos */
    handleNonNegativeNumberChange = (event) => {
        const { value } = event.target;
        const numero = Number(value);

        if (numero < 0) {
            return;
        }

        this.onChange(event);
    };

    render() {
        const {
            errors,
            isView,
            marcasveiculos,
            messageAlert,
            modeloveiculo,
            openAlert
        } = this.state;

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        style={{ flexWrap: 'wrap' }}
                    >
                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            Modelo de veículos {modeloveiculo.codmodeloveiculo}
                        </Typography>

                        <FormControlLabel
                            label={(modeloveiculo.inativo === ASIM) ? 'Inativo' : 'Ativo'}
                            control={
                                <Switch
                                    checked={!(modeloveiculo.inativo === ASIM)}
                                    name="inativo"
                                    onChange={this.onChange}
                                    color="primary"
                                    disabled={isView}
                                />
                            }
                        />
                    </Box>

                    <br />

                    <Box>
                        <TextField
                            label="Descrição"
                            name="descmodeloveiculo"
                            value={modeloveiculo.descmodeloveiculo || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            helperText={errors.descmodeloveiculo || ''}
                            error={!!errors.descmodeloveiculo}
                            disabled={isView}
                            inputProps={{ maxLength: 50 }}
                            fullWidth
                        />
                    </Box>

                    <br />

                    <Box
                        display="flex"
                        flexWrap="wrap"
                        style={{ gap: 12 }}
                    >
                        <FormControl
                            variant="outlined"
                            disabled={isView}
                            style={{
                                flex: 1,
                                minWidth: 220
                            }}
                        >
                            <ComboPadrao
                                name={'codmarcaveiculo'}
                                label={'Marca de veículo'}
                                value={modeloveiculo.codmarcaveiculo}
                                onChange={this.onChange}
                                helperText={errors.codmarcaveiculo || ''}
                                error={!!errors.codmarcaveiculo}
                                fieldId={'codmarcaveiculo'}
                                listItems={marcasveiculos}
                                fieldDescription={'descmarcaveiculo'}
                            />
                        </FormControl>

                        <TextField
                            label="Autonomia de KM percorrido"
                            name="autonomiakmperc"
                            value={modeloveiculo.autonomiakmperc || ''}
                            variant="outlined"
                            disabled={isView}
                            type="number"
                            inputProps={{ min: 0 }}
                            onChange={this.handleNonNegativeNumberChange}
                            style={{
                                flex: 1,
                                minWidth: 220
                            }}
                        />
                    </Box>

                    <br />
                    <br />

                    <Box
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 10
                        }}
                    >
                        <Button
                            name="salvar"
                            color="primary"
                            variant="contained"
                            onClick={this.onClickSave}
                            disabled={isView}
                        >
                            Salvar
                        </Button>

                        <Button
                            name="cancelar"
                            variant="contained"
                            onClick={this.onClickCancel}
                            color="secondary"
                        >
                            Cancelar
                        </Button>
                    </Box>
                </CardContent>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

export default ModeloVeiculoForm;